<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>캠페인 카테고리 관리</strong></div>
			<h2 class="h_sub">캠페인 카테고리 관리</h2>
		</div>

    <CampaignCategoryManageListForm/>
  </div>
</template>

<script>
import CampaignCategoryManageListForm from '@/components/admin/etc/CampaignCategoryManageListForm.vue';

export default {
  components: {
    CampaignCategoryManageListForm
  }
}
</script>
<style lang="">

</style>